import { PageRoots, portalPaths, UrlParams } from '@provision/portal-routes';
import { Navigate, Route } from 'react-router-dom';
import { CustomViews, CustomViewsFormView, CustomViewsListView } from 'src/pages/CustomViews';

import { getRoutePath } from 'src/routes/utils';

export const ViewsRoutes = ({ relative }: { relative?: boolean }) => (
  <Route path={getRoutePath(PageRoots.views, relative)} element={<CustomViews />}>
    {/* Default redirect on index */}
    <Route
      index
      element={
        <Navigate
          to={getRoutePath(portalPaths.customView.view('conversations'), relative)}
          replace
        />
      }
    />

    <Route
      path={getRoutePath(UrlParams.entityName, relative)}
      element={<CustomViewsListView />}
    />

    <Route
      path={getRoutePath(`${UrlParams.entityName}/update/${UrlParams.customViewId}`, true)}
      element={<CustomViewsFormView />}
    />
  </Route>
);
